import React, { ElementType, useState } from 'react'
import * as S from './index.style'
import Button from '@material-ui/core/Button'
import Grid from 'components/Grid'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import { InputBaseComponentProps } from '@material-ui/core'
import { Add } from '@styled-icons/material-rounded/Add'
import { Delete } from '@styled-icons/material-rounded/Delete'
import { DadosUrbanizacao, Custo, ValidacaoDadosUrbanizacao, dadosCustoValorDefault } from 'models/Viabilidade/Urbanizacao'
import { MascaraDecimal } from 'components/Mascara/Decimal'

export type CardUrbanizacaoProps = {
  /** Descricao do que a prop faz, vai direto pro storybook */
  tipoProjeto: string | number
  dadosUrbanizacao: DadosUrbanizacao
  dadosUrbanizacaoHandler: (novoValor: DadosUrbanizacao) => void
}

/** Descricao do que o componente faz, vai direto pro storybook */
const CardUrbanizacao: React.FC<CardUrbanizacaoProps> = ({ dadosUrbanizacao, dadosUrbanizacaoHandler }) => {
  const inicializarMensagensErro = () => {
    const vetor: Custo[] = []
    if (dadosUrbanizacao.itensUrbanizacao && dadosUrbanizacao.itensUrbanizacao.length > 0) {
      dadosUrbanizacao.itensUrbanizacao.forEach(() => {
        vetor.push(dadosCustoValorDefault)
      })
    }
    return new ValidacaoDadosUrbanizacao(vetor)
  }

  const [valores, setValores] = useState(dadosUrbanizacao)
  const [mensagensErro, setMensagensErro] = useState(inicializarMensagensErro())

  const adicionarDescricaoUrbanizacaoHandler = () => {
    const prevValores = { ...valores }
    const prevMensagensErro = mensagensErro

    prevValores.itensUrbanizacao = [...valores.itensUrbanizacao, { ...dadosCustoValorDefault }]
    prevMensagensErro.itensUrbanizacao = [...mensagensErro.itensUrbanizacao, { ...dadosCustoValorDefault }]

    setValores(prevValores)
    setMensagensErro(prevMensagensErro)
    dadosUrbanizacaoHandler(prevValores)
    validarCard(prevMensagensErro, prevValores)
  }

  const deletarDescricaoUrbanizacaoHandler = (index: number) => {
    const prevValores = { ...valores }
    const prevMensagensErro = mensagensErro

    prevValores.itensUrbanizacao.splice(index, 1)
    prevMensagensErro.itensUrbanizacao.splice(index, 1)

    prevValores.valorTotal = calcularValorTotal(prevValores.itensUrbanizacao)

    setValores(prevValores)
    setMensagensErro(prevMensagensErro)
    dadosUrbanizacaoHandler(prevValores)
    validarCard(prevMensagensErro, prevValores)
  }

  const descricaoUrbanizacaoHandler = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const state = replaceState(event, index)

    state.itensUrbanizacao[index].descricao = retirarCaracteresEspeciais(state.itensUrbanizacao[index].descricao)

    setValores(state)
    dadosUrbanizacaoHandler(state)
  }

  const valorUrbanizacaoHandler = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const state = replaceState(event, index)

    state.valorTotal = calcularValorTotal(state.itensUrbanizacao)

    setValores(state)
    dadosUrbanizacaoHandler(state)
  }

  const calcularValorTotal = (itensUrbanizacao: Custo[]): number => {
    return itensUrbanizacao.reduce((total: number, custo: Custo) => {
      const valor = custo.valor.toString()
      return (total += parseFloat(valor === '' ? '0' : valor))
    }, 0)
  }

  const replaceState = (event: React.ChangeEvent<HTMLInputElement>, index: number): DadosUrbanizacao => {
    const state = { ...valores } as DadosUrbanizacao

    const custo = {
      ...state.itensUrbanizacao[index],
      [event.target.name]: event.target.value
    }

    state.itensUrbanizacao[index] = custo

    return state
  }

  const retirarCaracteresEspeciais = (valor: string): string => {
    return valor.replace(/([^\w\sà-úÀ-Ú-])/gi, '')
  }

  const validarCampos = (index: number) => {
    if (valores.itensUrbanizacao[index].descricao != '' || valores.itensUrbanizacao[index].valor != '') {
      mensagensErro.itensUrbanizacao[index].descricao = mensagensErro.validarDescricao(valores.itensUrbanizacao[index].descricao)
      mensagensErro.itensUrbanizacao[index].valor = mensagensErro.validarValor(valores.itensUrbanizacao[index].valor as string)
    } else {
      mensagensErro.itensUrbanizacao[index].descricao = ''
      mensagensErro.itensUrbanizacao[index].valor = ''
    }

    const validador = new ValidacaoDadosUrbanizacao(mensagensErro.itensUrbanizacao)

    setMensagensErro(validador)
    validarCard(validador)
  }

  const validarCard = (validador: ValidacaoDadosUrbanizacao, novoState?: DadosUrbanizacao) => {
    let state
    if (novoState) {
      state = novoState
    } else {
      state = { ...valores } as DadosUrbanizacao
    }

    state.valido = validador.validarTodosCampos(state)
    setValores(state)
    dadosUrbanizacaoHandler(state)
  }

  return (
    <S.Wrapper>
      <Grid orientacao="column" gridTemplateColumns="4fr 1.5fr .5fr 2fr" gridGap="32px">
        <div>
          <S.Label>Descrição</S.Label>
        </div>
        <div>
          <S.Label>Valor (R$)</S.Label>
        </div>
        <div></div>
        <div>
          <S.Label>Valor Total (R$)</S.Label>
        </div>
      </Grid>

      {valores.itensUrbanizacao.map((custo: Custo, index: number) => (
        <Grid key={`urbanizacaoCusto${index}`} orientacao="column" gridTemplateColumns="4fr 1.5fr .5fr 2fr" gridGap="32px" margin="0 0 16px 0">
          <TextField
            placeholder="-"
            type="text"
            name="descricao"
            data-cy={`campoDescricao_${index}`}
            variant="outlined"
            size="small"
            value={custo.descricao}
            inputProps={{ maxLength: 100 }}
            onBlur={() => {
              validarCampos(index)
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              descricaoUrbanizacaoHandler(event, index)
            }}
            error={mensagensErro.itensUrbanizacao[index].descricao != ''}
            helperText={mensagensErro.itensUrbanizacao[index].descricao}
          />

          <TextField
            placeholder="00"
            type="text"
            name="valor"
            data-cy={`campoValor_${index}`}
            variant="outlined"
            size="small"
            value={custo.valor}
            onBlur={() => {
              validarCampos(index)
            }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              valorUrbanizacaoHandler(event, index)
            }}
            InputProps={{
              inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
            }}
            error={mensagensErro.itensUrbanizacao[index].valor != ''}
            helperText={mensagensErro.itensUrbanizacao[index].valor}
          />

          <div>
            {index > 0 && (
              <IconButton
                color="primary"
                style={{ marginTop: '8px' }}
                data-cy={`btnDeleteCusto_${index}`}
                aria-label="delete"
                onClick={() => {
                  deletarDescricaoUrbanizacaoHandler(index)
                }}
              >
                <Delete size={24} />
              </IconButton>
            )}
          </div>

          <div>
            {index === 0 && (
              <TextField
                disabled
                placeholder="00,0"
                type="text"
                name="valorTotal"
                data-cy="campoValorTotal"
                variant="outlined"
                size="small"
                value={valores.valorTotal}
                InputProps={{
                  inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>
                }}
              />
            )}
          </div>
        </Grid>
      ))}

      <Button
        type="button"
        data-cy="btnNovaDescricao"
        variant="contained"
        style={{ height: '40px' }}
        color="secondary"
        startIcon={<Add size={24} />}
        onClick={adicionarDescricaoUrbanizacaoHandler}
      >
        Nova descrição
      </Button>
    </S.Wrapper>
  )
}

export default CardUrbanizacao
